import React from 'react'

function Footer() {
  return (
    <>
    <div className="footer">
    <p className='footerText'>Copyright © <b>2018</b> All rights reserved. Design: Template Mo</p>
    </div>
    </>
  )
}

export default Footer